export default __webpack_public_path__ + "static/media/03__o_1.588426f4.jpg";